export default "__VITE_ASSET__CsgMCu51__"